import React from 'react';

interface ClaimToggleSectionProps {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const ClaimToggleSection: React.FC<ClaimToggleSectionProps> = ({
  title,
  isOpen,
  onToggle,
  children,
}) => {
  return (
    <div className="mt-6">
      <button
        type="button"
        className="w-full flex items-center justify-between text-left"
        onClick={onToggle}
      >
        <span className="text-[2vw] font-normal tracking-wide max-lg:text-[4vw] max-m:text-[5vw] text-[#2e313f]">
          {title}
        </span>

        <svg
          className={`w-6 h-6 text-primary transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && <div>{children}</div>}
    </div>
  );
};
